module.exports = __webpack_public_path__ + "img/sweden-ill-defined-causes-female.20917d95.png";